// Apparition en fondu des blocs de la collection (prototype `demos/ux/def/main.js`).
// Une seule fois par élément : la collection n'est pas une animation, c'est une entrée en matière.
// Le module est chargé par chaque section qui en a besoin — d'où le garde-fou d'exécution unique.
if (!window.__sdmReveal) {
  window.__sdmReveal = true;

  const io = new IntersectionObserver((entries) => {
    for (const en of entries) {
      if (!en.isIntersecting) continue;
      en.target.classList.add('in');
      io.unobserve(en.target);
    }
  }, { threshold: 0.15 });

  const observe = () => document.querySelectorAll('.sdm-reveal:not(.in)').forEach((el) => io.observe(el));
  observe();

  // Filet : une capture plein cadre redimensionne la fenêtre sans faire défiler, l'observateur ne voit alors
  // jamais le bas de page. Passé ce délai, tout ce qui reste caché est montré.
  setTimeout(() => document.querySelectorAll('.sdm-reveal:not(.in)').forEach((el) => el.classList.add('in')), 2000);

  // L'éditeur de thème ajoute et retire des sections sans recharger la page : on réobserve à chaque fois.
  document.addEventListener('shopify:section:load', observe);
  document.addEventListener('shopify:block:select', observe);
}
